<template>
  <div class="mask" v-show="modelType">
    <div class="mask-bg" @click.stop="closePanel"></div>
    <div class="model-panel" v-show="modelType === 1">
      <img class="icon-close-mask active" @click.stop="closePanel" src="@/assets/sakuraBox/icon-close-mask.png" alt="" />
      <img class="model-share-title" src="@/assets/sakuraBox/model-share-title.png" alt="" />
      <div class="share-type-list">
        <div class="shart-type" @click.stop="shareWeb(0x1)">
          <img class="active" src="@/assets/sakuraBox/icon-wechat.png" alt="" />
          微信
        </div>
        <div class="shart-type" @click.stop="shareWeb(0x2)">
          <img class="active" src="@/assets/sakuraBox/icon-friend-circle.png" alt="" />
          朋友圈
        </div>
        <div class="shart-type" @click.stop="shareWeb(0x3)">
          <img class="active" src="@/assets/sakuraBox/icon-qq.png" alt="" />
          QQ
        </div>
        <div class="shart-type" @click.stop="shareWeb(0x4)">
          <img class="active" src="@/assets/sakuraBox/icon-zone.png" alt="" />
          QQ空间
        </div>
      </div>
    </div>
    <div class="model-panel" v-show="modelType === 2">
      <img class="icon-close-mask active" @click.stop="closePanel" src="@/assets/sakuraBox/icon-close-mask.png" alt="" />
      <div class="block-name">
        <img src="@/assets/sakuraBox/title-block-tip.png" alt="" />
      </div>
      <div class="tip-detail">
        <p>樱花校园模拟器由233乐园独家代理。</p>
        小伙伴们可以在233乐园内体验最新版本 的樱花校园模拟器，还有丰富的游戏攻
        略，精彩的周边分享，赶紧来体验吧。
      </div>
      <img class="btn-download active" @click="openPageInApp" src="@/assets/sakuraBox/btn-download.png" alt="" />
    </div>
    <div class="model-panel" v-show="modelType === 3">
      <img class="icon-close-mask active" @click.stop="closePanel" src="@/assets/sakuraBox/icon-close-mask.png" alt="" />
      <div class="rule-tab">
        <div class="tab-box" @click="tabIndex = 1" :style="{ color: tabIndex === 1 ? 'white' : '#FFA0C0' }">导出文档</div>
        <div class="tab-box" @click="tabIndex = 2" :style="{ color: tabIndex === 2 ? 'white' : '#FFA0C0' }">导入文档</div>
        <div class="tab-slide" :style="{ left: tabIndex === 1 ? 0 : '1.3rem' }"></div>
      </div>
      <div class="scroll-rule" ref="scrollRule">
        <div v-show="tabIndex === 1" class="content" v-html="exportData"></div>
        <div v-show="tabIndex === 2"  class="content" v-html="importData"></div>
      </div>
    </div>
    <div class="guideMask" v-show="modelType === 4" @click.stop="closePanel">
      <img src="@/assets/images/guide_icon.png" alt="">
    </div>
    <div class="model-panel" v-show="modelType === 5">
      <template v-if="feedback">
        <img class="icon-close-mask active" @click.stop="closePanel" src="@/assets/sakuraBox/icon-close-mask.png" alt="" />
        <div class="feedback-warp">
            <div class="feedback-title">意见反馈</div>
            <div class="feedback-desc">问题描述 ：</div>
            <div class="feedback-input">
              <textarea v-model="content" placeholder="请输入问题描述" rows="4"></textarea>
            </div>
            <div class="feedback-desc">联系方式：</div>
            <div class="feedback-input">
              <input  @input="contact=contact.replace(/[^0-9]/g,'')" v-model="contact" placeholder="请输入联系方式" type="text">
            </div>
            <div @click="sukuraBoxSendFeedback" class="feedback-btn">提交反馈</div>
        </div>
      </template>
      <template v-else>
        <img class="icon-close-mask active" @click.stop="closePanel" src="@/assets/sakuraBox/icon-close-mask.png" alt="" />
        <img class="icon-feedback-success" src="@/assets/sakuraBox/icon-feedback-success.png" alt="">
        <div class="fb-result">反馈成功</div>
        <div class="fb-desc">感谢你的反馈！我们会做的更好~</div>
        <div class="fb-close-btn" @click.stop="closePanel">关闭</div>
      </template>
    </div>
  </div>
</template>

<script>
import config from "@/../config";
import active from "@/utils/axios/index";
import { mapState } from "vuex";
import primaryApi from '@/utils/primaryApi'
import { openApp } from "@/utils/utils";
import qs from "qs";
export default {
  props: ["modelType","shareArcId"],
  components: {},
  data() {
    return {
      tabIndex: 1,
      content:'',
      contact:'',
      shareData: { // 分享信息
        title: '樱校存档大全',
        shareDescribe: '樱校存档大全，海量游戏存档一键复制便捷使用，赶紧来体验',
        icon: 'https://cdn.233xyx.com/upload/video/feng.lin1617934148638/1.webp.jpg'
      },
      shareUrlArr: [], // 分享链接数组
      globalStates:{},
      exportData: '', // 导出文档
      importData: '', // 导入文档
      feedback: true // 是否显示意见反馈
    };
  },
  computed:{
    ...mapState([
      "uuid"
    ]),
  },
  watch:{
    tabIndex(){
      this.$refs.scrollRule.scrollTo(0, 0)
    },
    modelType(value){
      if(!value){
        document.documentElement.style.overflow='scroll';
        document.body.style.position='static';
      }else{
        document.documentElement.style.overflow= 'hidden';
        document.body.style.position= 'fixed';
        document.body.style.top= 0
      }
    }
  },
  mounted() {
    this.sukuraBoxPaper()
    this.getShareCsvByLocationId();
    /* 状态管理 */
    if (this.$route.query.f) {
        // 通过链接中是否存在分享id，判断是否通过分享进入
        this.globalStates = {
            shareParams: {
                locationId: parseInt(this.$route.query.f) || -1, // 分享功能ID
                relationship: parseInt(this.$route.query.g), // 分享关系
                relationshipParams: parseInt(this.$route.query.c) || -1, // 分享关系参数
                parentUUID: this.$route.query.u, // 分享人的UUID
                scheme: "",
                parentName: this.$route.query.n || "none", // 分享人的用户名
                isHelp: this.$route.query.h || 0 // 分享行为是否为请求好友助力 1是0否
            },
        };
    } else {
        // 非分享进入，分享中转信息写死
        this.globalStates = {
            shareParams: {
                locationId: -1, // 分享功能ID
                relationship: 5, // 分享关系
                relationshipParams: -1, // 分享关系参数
                parentUUID: "none", // 分享人的UUID
                scheme: "",
                parentName: "none", // 分享人的用户名
                isHelp: 0 // 分享行为是否为请求好友助力 1是0否
            },
        };
    }
  },
  methods: {
    sukuraBoxPaper(){
      active.sukuraBoxPaper(config.SAKURA_BASE_URL + '/api/sakura/paper',{}).then(res =>{
        if(res.return_code == 200 || res.code == 200){
          this.exportData = res.data.export
          this.importData = res.data.import
        }else{
          this.$toast(res.return_msg || res.message || res.msg)
        }
      })
    },
    // 提交意见反馈
    sukuraBoxSendFeedback(){
      if(!this.content){
        this.$toast('请输入你要反馈的建议')
        return
      }
      active.sukuraBoxSendFeedback(config.SAKURA_BASE_URL + '/api/sendFeedback',qs.stringify({
        type:1,
        content: this.content,
        contact: this.contact
      })).then(res =>{
        if(res.return_code == 200 || res.code == 200){
          this.content = ''
          this.contact = ''
          this.feedback = false
        }else{
          this.$toast(res.return_msg || res.message || res.msg)
        }
      })
    },
    openPageInApp(){
      const ua = navigator.userAgent.toLowerCase();
      this.$tea('event_sakura_box_download_click',{source: 'web'}) // 点击下载233乐园按钮的点击次数
      const activeObj = {
          activityId: -1,
          relationship: 4,
          guide: true
      } // 活动相关数据
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.$emit('openPanel', 4);
      } else {
        openApp(activeObj,this.globalStates,'sakuraBox');
      }
    },
    // 获取分享域名
    getShareCsvByLocationId() {
      active .shareInfo(
        config.API_HOST + "/apiserv/api/share/getShareCsvByLocationId", {
          locationId: 202, // 定制活动:202,活动模板:201
        }).then((res) => {
          if (res.return_code != 200) {
            this.$toast(res.return_msg);
            return;
          }
          this.shareUrlArr = res.data;
        }).catch((error) => {
          this.$toast("网络不稳定，请稍后");
        });
    },
    // 分享
    shareWeb(shareType) {
      if (!this.$parent.correctTerminal()) { // 判断运行环境是否是233
        return false;
      }
      let shareStyle;
      let url;
      let shareUrl;
      switch (shareType) {
        case 0x1:
          shareStyle = 0x15;
          this.shareUrlArr.map((item) => {
            if (item.shareApp == "1") {
              // shareApp = 1微信、2朋友圈、3QQ、4QQ空间
              shareUrl = item.domain.domain;
            }
          });
          break;
        case 0x2:
          shareStyle = 0x16;
          this.shareUrlArr.map((item) => {
            if (item.shareApp == "2") {
              shareUrl = item.domain.domain;
            }
          });
          break;
        case 0x3:
          shareStyle = 0x1f;
          this.shareUrlArr.map((item) => {
            if (item.shareApp == "3") {
              shareUrl = item.domain.domain;
            }
          });
          break;
        case 0x4:
          shareStyle = 0x20;
          this.shareUrlArr.map((item) => {
            if (item.shareApp == "4") {
              shareUrl = item.domain.domain;
            }
          });
          break;
      }
      const env = window._API_HOST().NODE_ENV;
      const shareBaseHost = window._API_HOST().shareBaseHost;
      if (env === "production") {
        // 正式服
        url = shareUrl;
      } else {
        // 测试，预发
        url = shareBaseHost;
      }
      let shareInfo = {
        // 分享网页4个参数
        targetUrl: url + "sakuraBox?u=" + this.uuid + "&f=-1" + "&g=4", // 分享链接 f-分享功能ID,g-分享关系,c-分享关系参数,u-分享人的UUID
        title: this.shareData.title, // 分享标题
        desc: this.shareData.shareDescribe, // 分享描述
        imgUrl: this.shareData.icon, // 分享图标
        // web
        shareType: shareType, // Int 微信 0x1，微信朋友圈 0x2，QQ 0x3，QQ空间 0x4
        shareStyle: shareStyle, // 落地分享展现方式, 只分享文字 0xB,微信网页 0x15,微信朋友圈分享网页 0x16,qq分享网页 0x1f,qq空间分享网页 0x20
        isWeb: true, // 是否由web端创建对话框
        locationId: 301, //Int 功能ID
        relationship: 4, //Int 关系（3:游戏分享）
        relationshipExtra: -1, //Long关系参数（3：gameId） string
        pos: 2001, //Int APP进入位置
        posExtra: -1, //Long APP进入位置参数
      };
      if (primaryApi.share(shareInfo) && this.shareArcId) {// 调用安卓api分享
        this.sukuraBoxOpArc();
      }
    },
    // 关闭弹窗
    closePanel() {
      this.feedback = true;
      this.content = '';
      this.contact = '';
      this.$emit('closePanel');
    },
    // 统计分享次数
    sukuraBoxOpArc(){
        this.$tea('event_sakura_box_arc_op_click',{ sakura_arc_id: this.shareArcId, sakura_op: 3 }) // 单个存档的分享次数、点赞次数、收藏次数、复制ID次数
        active.sukuraBoxOpArc(config.SAKURA_BASE_URL + '/api/sakura/opArc',qs.stringify({
            op: 3,
            arc_id: this.shareArcId,
            _token: window.localStorage.getItem('sakuraToken')
        })).then(res =>{
            if(res.return_code == 200 || res.code === 200){
                console.log('分享成功')
            }
        })
    },
  },
};
</script>

<style scoped>
.mask {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
}
.mask-bg{
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}
.model-panel {
  width: 351px;
  border-radius: 9px;
  background: white;
  border: 1px solid #fa7cb5;
  position: absolute;
  top: 50%;
  left: 12px;
  padding-bottom: 32px;
  padding-top: 12px;
  transform: translateY(-50%);
}
.model-share-title {
  width: 77px;
  height: 15px;
  display: block;
  margin: 14px auto 26px auto;
}
.share-type-list {
  display: flex;
  justify-content: space-between;
  padding: 0 32px;
}
.shart-type {
  width: 50px;
  text-align: center;
  font-size: 12px;
  color: #585858;
}
.shart-type img {
  width: 50px;
  height: 50px;
  display: block;
  margin-bottom: 12px;
}
.icon-close-mask {
  width: 13px;
  height: 13px;
  position: absolute;
  top: 17px;
  right: 20px;
}
.active:active {
  transform: scale(0.9);
}
.block-name {
  width: 232px;
  height: 24px;
  margin: 0.17rem auto 0.2rem auto;
  background: url("~assets/sakuraBox/title-bg.png") no-repeat;
  background-size: 100% 18px;
  background-position: center bottom;
  position: relative;
}
.block-name img {
  width: 103px;
  height: 24px;
  margin: 0 auto;
  display: block;
}
.tip-detail {
  font-size: 16px;
  padding: 6px 32px;
}
.tip-detail p {
  color: #ff7aa1;
}
.btn-download {
  width: 229px;
  height: 50px;
  margin: 20px auto 0 auto;
  display: block;
}
.rule-tab {
  width: 255px;
  height: 32px;
  border-radius: 16px;
  background: #ffe4ee;
  margin: 16px auto;
  line-height: 32px;
  position: relative;
}
.tab-box {
  width: 50%;
  float: left;
  text-align: center;
  color: #ffa0c0;
  position: relative;
  z-index: 2;
}
.tab-slide {
  width: 125px;
  height: 30px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 16px;
  background: #ff7aa1;
  transition: all 0.2s linear;
}
.scroll-rule {
  width: 316px;
  height: 420px;
  margin: 0 auto;
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}
.scroll-rule::-webkit-scrollbar {
  display: block;
  width: 3px;
  height: 3px;
}
.scroll-rule::-webkit-scrollbar-track {
  background: white;
  border-radius: 3px;
}
.scroll-rule::-webkit-scrollbar-thumb {
  background: #ffe4ee;
  border-radius: 3px;
}
.scroll-rule::-webkit-scrollbar-thumb:hover {
  background: #ffe4ee;
}
.content >>> img{
  width: 100% !important;
  display: block;
  margin: 5px 0;
}
.guideMask {
	position: relative;
	z-index: 1;
	text-align: right;
	padding-right: 10px;
	padding-top: 10px;
}
.guideMask img {
	width: 300px;
}
.feedback-warp{
  padding: 12px 20px 0 20px;
}
.feedback-title{
  font-size: 21px;
  font-weight: 500;
  color: #1a1a1a;
  padding-left: 26px;
  background: url("~assets/sakuraBox/icon-feedback-pink.png") no-repeat;
  background-size: 18px 18px;
  background-position: left center;
}
.feedback-desc{
  height: 38px;
  line-height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: #2F2F2F;
}
.feedback-input{
  width: 100%;
  padding: 12px;
  border: 1px solid #ECECEC;
  border-radius: 6px;
}
.feedback-input input{
  font-size: 14px;
  background: none;
  border:none;
  height: 18px;
  line-height: 18px;
}
.feedback-input textarea{
  width: 100%;
  border:none;
  resize: none;
}
.feedback-btn{
  width: 100%;
  height: 48px;
  line-height: 48px;
  text-align: center;
  color: white;
  font-size: 16px;
  font-weight: 500;
  background: #F967A4;
  border-radius: 48px;
  margin-top: 16px;
}
.feedback-btn:active{
  transform: scale(0.9);
}
.icon-feedback-success{
  width: 102px;
  height: 102px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%,-30%);
}
.fb-result{
  margin-top: 86px;
  font-size: 25px;
  font-weight: 500;
  color: #1A1A1A;
  text-align: center;
}
.fb-desc{
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  color: #A1A6A8;
  line-height: 16px;
  margin-top: 16px;
}
.fb-close-btn{
  width: 156px;
  height: 48px;
  line-height: 48px;
  color: #F967A4;
  border: 1px solid #F967A4;
  border-radius: 24px;
  margin: 25px auto 0 auto;
  font-size: 16px;
  text-align: center;
}
</style>
